"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeftSider = exports.Content = exports.Layout = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var antd_1 = require("antd");
var VarnishContext_1 = require("./VarnishContext");
exports.Layout = (0, styled_components_1.default)(antd_1.Layout)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    // as any here is fixing a bug: Exported variable 'Layout' has or is using name 'LayoutType'\n    // from external module \".../node_modules/antd/es/layout/index\" but cannot be named.\n    && {\n        // if the user passes a key to the color theme, use the mapped color,\n        // else treat the string as a normal color string\n        background: ", ";\n    }\n"], ["\n    // as any here is fixing a bug: Exported variable 'Layout' has or is using name 'LayoutType'\n    // from external module \".../node_modules/antd/es/layout/index\" but cannot be named.\n    && {\n        // if the user passes a key to the color theme, use the mapped color,\n        // else treat the string as a normal color string\n        background: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme, bgcolor = _a.bgcolor;
    return bgcolor ? (theme.color[bgcolor] ? theme.color[bgcolor] : bgcolor) : 'none';
});
var Content = function (_a) {
    var children = _a.children, main = _a.main, className = _a.className, basicProps = __rest(_a, ["children", "main", "className"]);
    return (React.createElement(VarnishContext_1.VarnishContext.Consumer, null, function (_a) {
        var layout = _a.layout;
        return main ? (React.createElement(MainContent, __assign({ layout: layout, className: className }, basicProps), children)) : (React.createElement(NotMainContent, __assign({ layout: layout, className: className }, basicProps), children));
    }));
};
exports.Content = Content;
var contentCSS = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    max-width: ", ";\n    width: 100%;\n    ", "\n    padding: ", ";\n\n    @media (max-width: ", ") {\n        padding: ", ";\n    }\n"], ["\n    max-width: ", ";\n    width: 100%;\n    ", "\n    padding: ", ";\n\n    @media (max-width: ", ") {\n        padding: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme, layout = _a.layout;
    return layout === 'center-aligned' ? theme.breakpoints.xl.toString() : null;
}, function (_a) {
    var layout = _a.layout;
    return (layout === 'center-aligned' ? 'margin: 0 auto;' : '');
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.lg.toString();
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.sm.toString();
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.sm.toString();
});
var MainContent = (0, styled_components_1.default)(antd_1.Layout.Content)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), contentCSS);
var NotMainContent = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), contentCSS);
var LeftSider = function (props) { return (React.createElement(VarnishContext_1.VarnishContext.Consumer, null, function (_a) {
    var currentHeaderHeight = _a.currentHeaderHeight;
    return (React.createElement(StyledLeftSider, __assign({ trigger: null, breakpoint: "md" }, props),
        React.createElement(FixedContainer, { paddingTop: currentHeaderHeight, breakpoint: props.breakpoint || 'md', width: props.width, collapsedWidth: props.collapsedWidth }, props.children)));
})); };
exports.LeftSider = LeftSider;
var StyledLeftSider = (0, styled_components_1.default)(antd_1.Layout.Sider)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    background: ", ";\n    transition: none;\n"], ["\n    background: ", ";\n    transition: none;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.white.toString();
});
var FixedContainer = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    border-right: 1px solid ", ";\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    width: ", ";\n    padding-top: ", "px;\n    transition: padding-top 200ms ease-in-out;\n    overflow: auto;\n\n    @media screen and (max-width: ", ") {\n        width: ", ";\n    }\n"], ["\n    border-right: 1px solid ", ";\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    width: ", ";\n    padding-top: ", "px;\n    transition: padding-top 200ms ease-in-out;\n    overflow: auto;\n\n    @media screen and (max-width: ", ") {\n        width: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.border.default.toString();
}, function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var paddingTop = _a.paddingTop;
    return paddingTop;
}, function (_a) {
    var theme = _a.theme, breakpoint = _a.breakpoint;
    return theme.breakpoints[breakpoint].toString();
}, function (_a) {
    var collapsedWidth = _a.collapsedWidth;
    return collapsedWidth;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Layout.js.map